import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { StyledAnimatedOnHover } from './SideTree';
import { Teams } from '../../utils/teams';
import * as actions from '../../actions';
import { useAppDispatch } from '../../utils/modules';

interface IOrderByIconContainerProps {
	firstColor: string;
	secondColor: string;
}
const OrderByIconContainer = styled(StyledAnimatedOnHover)<IOrderByIconContainerProps>`
	display: flex;
	margin: auto 5px 0 5px;
	cursor: pointer;
	a {
		color: transparent;
	}
	i {
		font-size: 15px;
		line-height: 30px;
		cursor: pointer;
		color: ${props => `#${props.firstColor}`};
		text-shadow: ${props => `-1px 0 #${props.secondColor}, 0 1px #${props.secondColor}, 1px 0 #${props.secondColor}, 0 -1px #${props.secondColor}`};
		:hover {
			color: ${props => `#${props.secondColor}`};
			text-shadow: ${props => `-1px 0 #${props.firstColor}, 0 1px #${props.firstColor}, 1px 0 #${props.firstColor}, 0 -1px #${props.firstColor}`};
		}
	}
`;

//#endregion


interface IReserveTeamInfo {
	countryCode: string;
	firstColor: string;
	secondColor: string;
}
export default function ReserveTeamInfo({ countryCode, firstColor, secondColor }: IReserveTeamInfo) {

	const dispatch = useAppDispatch();


	const text = useMemo(() => {
		return Teams.getReserveTeamTextByCountry(countryCode);
	}, [countryCode]);
	
	const clickAsterisk = useCallback((e: React.MouseEvent) => {
		dispatch(actions.setReserveTeamTooltip({ text, x: e.clientX, y: e.clientY }));
	}, [text, dispatch]);

	return (
		<OrderByIconContainer
			firstColor={firstColor}
			secondColor={secondColor}
		>
			<i
				className='fa fa-asterisk'
				onClick={clickAsterisk}
				title={text}
				
			/>
		</OrderByIconContainer>
	);
}
